import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { adminService } from '../../services/api';
import '../../styles/Admin.css';

const AdminDashboard = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    totalUsers: 0,
    pendingProfiles: 0,
    approvedProfiles: 0,
    loading: true,
    error: null
  });
  
  // Vérifier si l'utilisateur est admin et charger les statistiques
  useEffect(() => {
    const loadStats = async () => {
      if (!currentUser || !currentUser.isAdmin) {
        navigate('/');
        return;
      }

      try {
        setStats(prev => ({ ...prev, loading: true, error: null }));
        
        // Récupérer les statistiques depuis l'API
        const [users, profiles] = await Promise.all([
          adminService.getUsersStats(),
          adminService.getProfilesStats()
        ]);

        setStats({
          totalUsers: users.total || 0,
          pendingProfiles: profiles.pending || 0,
          approvedProfiles: profiles.approved || 0,
          loading: false,
          error: null
        });
      } catch (error) {
        console.error('Erreur lors du chargement des statistiques:', error);
        setStats(prev => ({
          ...prev,
          loading: false,
          error: 'Erreur lors du chargement des statistiques'
        }));
      }
    };

    loadStats();
  }, [currentUser, navigate]);

  return (
    <div className="admin-dashboard">
      <div className="container">
        <h1 className="page-title">Tableau de bord d'administration</h1>
        
        <div className="admin-cards">
          <div className="admin-card" onClick={() => navigate('/admin/users')}>
            <div className="admin-card-icon">👤</div>
            <h2>Gestion des utilisateurs</h2>
            <p>Gérer les comptes utilisateurs, modifier les rôles et les permissions</p>
          </div>
          
          <div className="admin-card" onClick={() => navigate('/admin/profiles')}>
            <div className="admin-card-icon">📋</div>
            <h2>Approbation des profils</h2>
            <p>Approuver ou rejeter les profils utilisateurs et leurs modifications</p>
          </div>
          
          <div className="admin-card" onClick={() => navigate('/admin/expertises')}>
            <div className="admin-card-icon">🔍</div>
            <h2>Gestion des expertises</h2>
            <p>Ajouter, modifier ou supprimer des domaines d'expertise</p>
          </div>
          
          <div className="admin-card" onClick={() => navigate('/admin/networks')}>
            <div className="admin-card-icon">🌐</div>
            <h2>Gestion des réseaux</h2>
            <p>Ajouter, modifier ou supprimer des réseaux et groupes de recherche</p>
          </div>
          
          <div className="admin-card" onClick={() => navigate('/admin/organizations')}>
            <div className="admin-card-icon">🏢</div>
            <h2>Gestion des organisations</h2>
            <p>Gérer les organisations des utilisateurs (universités, laboratoires, etc.)</p>
          </div>
        </div>
        
        <div className="admin-stats">
          <h2>Statistiques du système</h2>
          {stats.loading ? (
            <div className="loading">Chargement des statistiques...</div>
          ) : stats.error ? (
            <div className="error-message">{stats.error}</div>
          ) : (
            <div className="stats-grid">
              <div className="stat-card">
                <h3>Utilisateurs</h3>
                <p className="stat-number">{stats.totalUsers}</p>
              </div>
              <div className="stat-card">
                <h3>Profils en attente</h3>
                <p className="stat-number">{stats.pendingProfiles}</p>
              </div>
              <div className="stat-card">
                <h3>Profils approuvés</h3>
                <p className="stat-number">{stats.approvedProfiles}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
